import { render, staticRenderFns } from "./lazadaStockList.vue?vue&type=template&id=03006183&"
import script from "./lazadaStockList.vue?vue&type=script&lang=js&"
export * from "./lazadaStockList.vue?vue&type=script&lang=js&"
import style0 from "./lazadaStockList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports